// TODO: big refactor to use as little of this as possible in the codebase/ deprecate it if possible. Think of different way of handling the types more consistently with the actual types in the code
/**
 * enum values for syntax nodes from the tab-edit/parser-tablature package. (should probably be defined in that package instead.)
 */
export enum SourceNodeTypes {
    Top = "Tablature",
    TabSegment = "TabSegment",
    TabSegmentLine = "TabSegmentLine",
    TabString = "TabString",
    MeasureLineName = "MeasureLineName",
    MeasureLine = "MeasureLine",

    Note = "Note",
    NoteDecorator = "NoteDecorator",
    NoteConnector = "NoteConnector",
    ConnectorSymbol = "ConnectorSymbol",

    Hammer = "Hammer",
    Pull = "Pull",
    Slide = "Slide",
    Fret = "Fret",
    Harmonic = "Harmonic",
    Grace = "Frace",
    Comment = "Comment",
    Component = "Component",
    Connector = "Connector",

    RepeatLine = "RepeatLine",
    Repeat = "Repeat",
    Multiplier = "Multiplier",
    TimeSignature = "TimeSignature",
    TimeSigLine = "TimeSigLine",
    TimingLine = "TimingLine",

    Modifier = "Modifier",
    
    InvalidToken = "⚠"
}

export enum ASTNodeTypes {
    TabSegment = "TabSegment",
    TabBlock = "TabBlock",
    Measure = "Measure",
    Sound = "Sound",
    MeasureLineName = "MeasureLineName",
    LineNaming = "LineNaming",
    Hammer = "Hammer",
    Pull = "Pull",
    Slide = "Slide",
    Grace = "Grace",
    Harmonic = "Harmonic",
    Fret = "Fret",
    Repeat = "Repeat",
    TimeSignature = "TimeSignature",
    Multiplier = "Multiplier",
    ConnectorGroup = "ConnectorGroup",
    Component = "Component",
    Connector = "Connector"
}
